<template>
    <div class="Belt">
        <Avatar :avatar="avatar" />
        <svgicon v-if="color" icon="belt" :color="color" />
    </div>
</template>

<script>
import Avatar from '@/components/Avatar';

export default {
    components: { Avatar },
    props: {
        color: {
            type: String,
            default: ''
        },
        avatar: {
            type: String,
            default: ''
        }
    }
};
</script>

<style lang="scss" scoped>
.Belt {
    position: relative;
    border-radius: 50%;

    $size: 3em;
    width: $size;
    height: $size;
}
.Avatar {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}
.svg-icon {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 40%;

    /deep/ path {
        stroke: black;
    }
}
</style>
